import React, { useState, useEffect, useRef } from "react";

export default function ProjektstatusOhneNotar({ adminView, objekte, userObjects, abwicklungObjekte }) {
   useEffect(() => {
      console.log(objekte);
   }, []);
   return (
      <>
         <div className="projektstatus-l2" style={{ flexGrow: 5 }}>
            <h2>
               <small>ohne Notartermin</small> | {objekte.length}
               {adminView && objekte && abwicklungObjekte && (
                  <div style={{ fontSize: "22px" }}>
                     {new Intl.NumberFormat("de-DE", {
                        style: "currency",
                        currency: "EUR",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                     }).format(
                        objekte.reduce(
                           (oldObj, item) =>
                              oldObj + (abwicklungObjekte[item.id] ? abwicklungObjekte[item.id].umsatz : 0),
                           0
                        )
                     )}
                  </div>
               )}
            </h2>
            {objekte &&
               abwicklungObjekte &&
               objekte.map((objekt, index) => (
                  <a
                     href={"/datenblatt?estateid=" + objekt.id}
                     target="_blank"
                     rel="noopener noreferrer"
                     className={"projektstatus-notartermin"}
                     key={"ohnetermin_" + objekt.id}
                  >
                     {objekt.objektbezeichnung
                        ? objekt.objektbezeichnung
                        : objekt.objektnr_extern +
                          " " +
                          (userObjects[objekt.benutzer] && userObjects[objekt.benutzer].Name)}
                     {objekt.abwicklungsdatum && (
                        <span>
                           <br />
                           In Abwicklung seit über{" "}
                           <strong> {Math.floor((new Date() - objekt.abwicklungsdatum) / 86400000)}</strong> Tagen{" "}
                        </span>
                     )}
                     {adminView && (
                        <div>
                           {abwicklungObjekte[objekt.id] && (
                              <span>
                                 {" "}
                                 {"VK: "}
                                 {new Intl.NumberFormat("de-DE", {
                                    style: "currency",
                                    currency: "EUR",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                 }).format(abwicklungObjekte[objekt.id].verkauft_fur)}
                                 {" U: "}
                                 {new Intl.NumberFormat("de-DE", {
                                    style: "currency",
                                    currency: "EUR",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                 }).format(abwicklungObjekte[objekt.id].umsatz)}
                              </span>
                           )}
                        </div>
                     )}
                  </a>
               ))}
         </div>
      </>
   );
}
